export default __webpack_public_path__ + "static/media/0xd86b5923f3ad7b585ed81b448170ae026c65ae9a.08a72653.png";